import { Outlet } from 'react-router';

import { Card } from '../../../common/Atoms/Card';
import { ITab, Tabs } from '../../../common/Atoms/Tabs';
import { Notification } from '../../../common/Atoms/Notification';

const tabs: ITab[] = [
  {
    name: `Email Inbox`,
    href: `email`,
  },
  {
    name: `SMS Inbox`,
    href: `sms`,
  },
];

export function InboxRoot() {
  return (
    <Card>
      <Tabs
        tabs={ tabs }
      />

      <Notification
        type={ `info` }
        className={ `mb-4` }
      >
        { `Improvements to the inbox are coming very soon!` }
      </Notification>

      <Outlet />
    </Card>
  );
}
